import React, { useEffect, useState, createElement } from 'react';
import { MessageSquare, ThumbsUp, Eye, Plus, Search, X, CheckCircle, Book, MessageCircle, Image as ImageIcon, Send, HelpCircle, Info, Upload, Trash2, CheckCheck, ArrowDownAZ, MessageSquareText, Heart, Filter, ChevronDown, Star, User, MessageSquareDashed, ListFilter, Bookmark } from 'lucide-react';
import { ForumTopic } from '../components/ForumTopic';
import { NewForumTopic } from '../components/NewForumTopic';
import { IconTooltip } from '../components/IconTooltip';
import { IconFilter } from '../components/IconTooltip';
import { useToast } from '../components/Toast';
// Define LGS subjects for forum categories
const lgsSubjects = [{
  id: 'turkce',
  title: 'Türkçe',
  topics: ['Sözcükte Anlam', 'Deyimler ve Atasözleri', 'Cümlede Anlam', 'Sözel Mantık / Görsel Okuma', 'Parçada Anlam', 'Söz Sanatları', 'Metin Türleri', 'Noktalama İşaretleri', 'Yazım Kuralları', 'Fiilimsiler', 'Cümlenin Öğeleri', 'Cümle Türleri', 'Anlatım Bozukluğu']
}, {
  id: 'matematik',
  title: 'Matematik',
  topics: ['Çarpanlar ve Katlar', 'Üslü Sayılar', 'Köklü Sayılar', 'Veri Analizi', 'Olasılık', 'Cebirsel İfadeler', 'Doğrusal Denklemler ve Eğim', 'Eşitsizlikler', 'Üçgenler', 'Eşlik ve Benzerlik', 'Dönüşüm Geometrisi', 'Geometrik Cisimler']
}, {
  id: 'fen',
  title: 'Fen Bilimleri',
  topics: ['Mevsimler ve İklim', 'DNA ve Genetik Kod', 'Basınç', 'Madde ve Endüstri', 'Basit Makineler', 'Enerji Dönüşümleri', 'Elektrik Yükleri']
}, {
  id: 'inkilap',
  title: 'T.C. İnkılap Tarihi',
  topics: ['Bir Kahraman Doğuyor', 'Milli Uyanış', 'Milli Bir Destan', 'Atatürkçülük', 'Demokratikleşme Çabaları', 'Atatürk Dönemi Dış Politika']
}, {
  id: 'ingilizce',
  title: 'İngilizce',
  topics: ['Friendship', 'Teen Life', 'In The Kitchen', 'On The Phone', 'The Internet', 'Adventures', 'Tourism', 'Chores', 'Science', 'Natural Forces']
}, {
  id: 'din',
  title: 'Din Kültürü',
  topics: ['Kader İnancı', 'Hz. Musa', 'Zekat ve Sadaka', 'Din ve Hayat', 'Hz. Muhammed', "Kur'an-ı Kerim", 'Paylaşma ve Yardımlaşma']
}];
interface ForumTopicType {
  id: number;
  title: string;
  author: string;
  authorType: 'student' | 'teacher';
  category: string;
  topic?: string;
  replies: number;
  views: number;
  likes: number;
  time: string;
  content?: string;
  visibility: 'public' | 'private' | 'institution';
  selectedUsers?: string[];
  type: 'question' | 'other';
  bestAnswerId?: number;
  teacherApprovedId?: number;
  solved?: boolean;
  image?: string;
  likedBy?: string[];
  mostLikedAnswerId?: number;
  repliedBy?: string[]; // Add this field to track who replied to this topic
  archived?: boolean;
}
export function Forum() {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Matematik':
        return 'bg-blue-400/10 text-blue-400';
      case 'Türkçe':
        return 'bg-red-400/10 text-red-400';
      case 'Fen Bilimleri':
        return 'bg-green-400/10 text-green-400';
      case 'T.C. İnkılap Tarihi':
        return 'bg-amber-400/10 text-amber-400';
      case 'İngilizce':
        return 'bg-indigo-400/10 text-indigo-400';
      case 'Din Kültürü':
        return 'bg-teal-400/10 text-teal-400';
      default:
        return 'bg-purple-400/10 text-purple-400';
    }
  };
  const [urlQuestionId, setUrlQuestionId] = useState<number | null>(null);
  const [topics, setTopics] = useState<ForumTopicType[]>(() => {
    const savedTopics = localStorage.getItem('forumTopics');
    return savedTopics ? JSON.parse(savedTopics) : [{
      id: 1,
      title: 'Üslü sayılar konusunda takıldığım bir soru var',
      author: 'Ahmet Y.',
      authorType: 'student',
      category: 'Matematik',
      topic: 'Üslü Sayılar',
      replies: 5,
      views: 123,
      likes: 8,
      likedBy: [],
      time: '2 saat önce',
      visibility: 'public',
      type: 'question',
      solved: true,
      teacherApprovedId: 3,
      mostLikedAnswerId: 2,
      repliedBy: ['currentUser'],
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWF0aCUyMHByb2JsZW18ZW58MHx8MHx8fDA%3D',
      content: 'Üslü sayılarla ilgili şu soruyu çözerken zorlanıyorum. Özellikle negatif kuvvetlerin olduğu kısımda işlem adımlarını anlamakta zorlanıyorum. Bu tür soruları çözerken nasıl bir yol izlemeliyim?'
    }, {
      id: 2,
      title: 'LGS Fen Bilimleri çalışma programı önerisi',
      author: 'Mehmet K.',
      authorType: 'student',
      category: 'Fen Bilimleri',
      topic: 'Genel',
      replies: 12,
      views: 345,
      likes: 24,
      likedBy: [],
      time: '5 saat önce',
      visibility: 'public',
      type: 'other',
      mostLikedAnswerId: 4,
      repliedBy: [],
      content: 'LGS Fen Bilimleri için etkili bir çalışma programı oluşturmak istiyorum. Hangi konulara öncelik vermeli ve nasıl bir çalışma takvimi oluşturmalıyım? Önerilerinizi paylaşırsanız çok sevinirim.'
    }, {
      id: 3,
      title: 'Sözcükte Anlam konusunda zorlandığım bir soru',
      author: 'Zeynep A.',
      authorType: 'student',
      category: 'Türkçe',
      topic: 'Sözcükte Anlam',
      replies: 3,
      views: 87,
      likes: 5,
      likedBy: [],
      time: '1 gün önce',
      visibility: 'public',
      type: 'question',
      bestAnswerId: 2,
      mostLikedAnswerId: 1,
      repliedBy: [],
      image: 'https://images.unsplash.com/photo-1596495577886-d920f1fb7238?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzB8fG1hdGglMjBwcm9ibGVtfGVufDB8fDB8fHww',
      content: 'Sözcükte Anlam konusunda şu soruyu çözerken zorlanıyorum: "Aşağıdaki cümlelerin hangisinde altı çizili sözcük mecaz anlamıyla kullanılmamıştır?" Benzer soruları çözerken nelere dikkat etmeliyim?'
    }, {
      id: 4,
      title: 'Hangi kaynak kitabı önerirsiniz?',
      author: 'Burak T.',
      authorType: 'student',
      category: 'Türkçe',
      topic: 'Genel',
      replies: 8,
      views: 156,
      likes: 12,
      likedBy: [],
      time: '3 gün önce',
      visibility: 'public',
      type: 'other',
      mostLikedAnswerId: 3,
      repliedBy: ['currentUser'],
      content: 'LGS Türkçe için soru bankası arıyorum. Özellikle paragraf soruları açısından zengin ve açıklamaları detaylı olan bir kaynak önerebilir misiniz? Şimdiden teşekkürler.'
    }, {
      id: 5,
      title: 'Bu cebirsel ifade sorusunu nasıl çözebilirim?',
      author: 'Ben',
      authorType: 'student',
      category: 'Matematik',
      topic: 'Cebirsel İfadeler',
      replies: 7,
      views: 112,
      likes: 15,
      likedBy: ['currentUser'],
      time: '1 gün önce',
      visibility: 'public',
      type: 'question',
      bestAnswerId: 3,
      mostLikedAnswerId: 2,
      repliedBy: [],
      content: 'Aşağıdaki cebirsel ifade sorusunda takıldım. 2x² + 5x - 3 ve x² - 2x + 1 ifadelerinin çarpımını en sade şekilde nasıl bulabilirim?'
    }, {
      id: 6,
      title: 'DNA replikasyonu sorusunu çözemiyorum',
      author: 'Ayşe L.',
      authorType: 'student',
      category: 'Fen Bilimleri',
      topic: 'DNA ve Genetik Kod',
      replies: 2,
      views: 205,
      likes: 32,
      likedBy: [],
      time: '4 gün önce',
      visibility: 'public',
      type: 'question',
      teacherApprovedId: 1,
      mostLikedAnswerId: 2,
      repliedBy: [],
      content: 'DNA replikasyonu ile ilgili şu soruyu çözemiyorum: "DNA replikasyonu sırasında, aşağıdaki enzimlerden hangisi DNA zincirini açarak replikasyonun başlamasını sağlar?" Seçenekler: A) DNA polimeraz B) Helikaz C) Ligaz D) RNA primaz'
    }, {
      id: 7,
      title: 'İngilizce kelime ezberlemede zorlanıyorum',
      author: 'Emre K.',
      authorType: 'student',
      category: 'İngilizce',
      topic: 'Genel',
      replies: 15,
      views: 278,
      likes: 28,
      likedBy: [],
      time: '2 gün önce',
      visibility: 'public',
      type: 'other',
      teacherApprovedId: 2,
      bestAnswerId: 4,
      mostLikedAnswerId: 1,
      repliedBy: [],
      content: 'İngilizce kelimeleri ezberlemekte çok zorlanıyorum. Ne kadar çalışsam da kısa sürede unutuyorum. Etkili kelime ezberleme teknikleri nelerdir? Hangi uygulamaları veya yöntemleri önerirsiniz?'
    }, {
      id: 8,
      title: 'Basınç formülleri ile ilgili bu soruyu çözebilir misiniz?',
      author: 'Ben',
      authorType: 'student',
      category: 'Fen Bilimleri',
      topic: 'Basınç',
      replies: 6,
      views: 98,
      likes: 10,
      likedBy: ['currentUser'],
      time: '3 gün önce',
      visibility: 'public',
      type: 'question',
      mostLikedAnswerId: 3,
      repliedBy: [],
      content: 'Aşağıdaki basınç sorusunda takıldım: "Bir sıvı içindeki cismin batma-yüzme durumu için hangisi doğrudur?" A) Cismin yoğunluğu sıvının yoğunluğundan büyükse cisim yüzer. B) Cismin yoğunluğu sıvının yoğunluğundan küçükse cisim batar. C) Cismin yoğunluğu sıvının yoğunluğuna eşitse cisim askıda kalır. D) Cismin yoğunluğu sıvının yoğunluğundan büyükse cisim askıda kalır.'
    }, {
      id: 9,
      title: 'T.C. İnkılap Tarihi kronolojisi',
      author: 'Selin Y.',
      authorType: 'student',
      category: 'T.C. İnkılap Tarihi',
      topic: 'Milli Bir Destan',
      replies: 8,
      views: 145,
      likes: 22,
      likedBy: [],
      time: '5 gün önce',
      visibility: 'institution',
      type: 'other',
      teacherApprovedId: 5,
      mostLikedAnswerId: 2,
      repliedBy: ['currentUser'],
      content: 'Kurtuluş Savaşı dönemindeki olayların kronolojik sıralamasını karıştırıyorum. Bu konuda akılda kalıcı bir özet veya kronoloji tablosu paylaşabilir misiniz?'
    }, {
      id: 10,
      title: 'Köklü sayılar konusunda bu soruyu çözemiyorum',
      author: 'Ben',
      authorType: 'student',
      category: 'Matematik',
      topic: 'Köklü Sayılar',
      replies: 4,
      views: 89,
      likes: 7,
      likedBy: [],
      time: '6 saat önce',
      visibility: 'public',
      type: 'question',
      repliedBy: [],
      content: 'Köklü sayılarla ilgili şu problemi çözemiyorum: "√12 + √27 - √75 işleminin sonucu kaçtır?" Adım adım çözümünü gösterebilir misiniz?'
    }, {
      id: 11,
      title: 'Olasılık probleminde takıldım, yardım edebilir misiniz?',
      author: 'Ben',
      authorType: 'student',
      category: 'Matematik',
      topic: 'Olasılık',
      replies: 0,
      views: 12,
      likes: 2,
      likedBy: [],
      time: '1 saat önce',
      visibility: 'public',
      type: 'question',
      repliedBy: [],
      content: 'Bir torbada 3 kırmızı, 4 mavi ve 5 yeşil top vardır. Torbadan rastgele 2 top çekildiğinde, her iki topun da aynı renk olma olasılığı nedir? Çözüm yolunu anlayamadım, yardımcı olabilir misiniz?'
    }];
  });
  const [selectedTopic, setSelectedTopic] = useState<ForumTopicType | null>(null);
  const [activeTab, setActiveTab] = useState<'question' | 'other'>('question');
  const [searchTerm, setSearchTerm] = useState('');
  const [showAskModal, setShowAskModal] = useState(false);
  const [askModalStep, setAskModalStep] = useState(1);
  const [askModalType, setAskModalType] = useState<'question' | 'other' | null>(null);
  const [showNewTopic, setShowNewTopic] = useState(false);
  // New state for subject and topic filtering
  const [selectedSubjectFilter, setSelectedSubjectFilter] = useState<string>('');
  const [selectedTopicFilter, setSelectedTopicFilter] = useState<string>('');
  const [availableTopicFilters, setAvailableTopicFilters] = useState<string[]>([]);
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  const [showTopicDropdown, setShowTopicDropdown] = useState(false);
  // Add state for personal filters
  const [personalFilter, setPersonalFilter] = useState<'all' | 'my-topics' | 'my-replies'>('all');
  // Add state for active filters
  const [activeFilters, setActiveFilters] = useState<{
    teacherApproved: boolean;
    studentSelected: boolean;
    mostLiked: boolean;
  }>({
    teacherApproved: false,
    studentSelected: false,
    mostLiked: false
  });
  // Add state for visibility filter
  const [visibilityFilter, setVisibilityFilter] = useState<'all' | 'public' | 'institution'>('all');
  const [showVisibilityDropdown, setShowVisibilityDropdown] = useState(false);
  // Update available topics when subject filter changes
  useEffect(() => {
    if (selectedSubjectFilter) {
      const subject = lgsSubjects.find(s => s.title === selectedSubjectFilter);
      if (subject) {
        setAvailableTopicFilters(subject.topics);
      } else {
        setAvailableTopicFilters([]);
      }
      setSelectedTopicFilter('');
    } else {
      setAvailableTopicFilters([]);
      setSelectedTopicFilter('');
    }
  }, [selectedSubjectFilter]);
  // Form state
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    topic: '',
    content: '',
    image: null as File | null,
    imagePreview: null as string | null,
    visibility: 'public' as 'public' | 'institution' | 'private',
    selectedTeachers: [] as string[]
  });
  // Available teachers for selection
  const availableTeachers = [{
    id: '1',
    name: 'Ahmet Yılmaz',
    subject: 'Matematik'
  }, {
    id: '2',
    name: 'Zeynep Kaya',
    subject: 'Türkçe'
  }, {
    id: '3',
    name: 'Mehmet Demir',
    subject: 'Fen Bilimleri'
  }, {
    id: '4',
    name: 'Ayşe Şahin',
    subject: 'İngilizce'
  }, {
    id: '5',
    name: 'Ali Öztürk',
    subject: 'Tarih'
  }, {
    id: '6',
    name: 'Fatma Çelik',
    subject: 'Coğrafya'
  }, {
    id: '7',
    name: 'Mustafa Aydın',
    subject: 'Fizik'
  }, {
    id: '8',
    name: 'Hatice Yıldız',
    subject: 'Kimya'
  }];
  const [searchTeacherTerm, setSearchTeacherTerm] = useState('');
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  // Available topics based on selected category
  const [availableTopics, setAvailableTopics] = useState<string[]>([]);
  // Update available topics when category changes
  useEffect(() => {
    if (formData.category) {
      const selectedSubject = lgsSubjects.find(subject => subject.title === formData.category);
      if (selectedSubject) {
        setAvailableTopics(selectedSubject.topics);
      } else {
        setAvailableTopics([]);
      }
    } else {
      setAvailableTopics([]);
    }
  }, [formData.category]);
  // Filter teachers based on search term
  const filteredTeachers = availableTeachers.filter(teacher => teacher.name.toLowerCase().includes(searchTeacherTerm.toLowerCase()) || teacher.subject.toLowerCase().includes(searchTeacherTerm.toLowerCase()));
  // Save topics to localStorage when they change
  useEffect(() => {
    localStorage.setItem('forumTopics', JSON.stringify(topics));
  }, [topics]);
  const [sortOption, setSortOption] = useState<'newest' | 'mostReplies' | 'mostLikes'>('newest');
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  // Sort topics based on selected option
  const sortTopics = (topics: ForumTopicType[]) => {
    switch (sortOption) {
      case 'newest':
        // Assuming 'time' field can be compared as is, or you might need to parse it
        return [...topics].sort((a, b) => {
          if (a.time === 'Şimdi') return -1;
          if (b.time === 'Şimdi') return 1;
          return a.time < b.time ? 1 : -1;
        });
      case 'mostReplies':
        return [...topics].sort((a, b) => b.replies - a.replies);
      case 'mostLikes':
        return [...topics].sort((a, b) => b.likes - a.likes);
      default:
        return topics;
    }
  };
  // Filter topics based on search term, subject, topic filters, active filters, and personal filters
  const filteredTopics = topics.filter(topic => topic.type === activeTab).filter(topic => topic.title.toLowerCase().includes(searchTerm.toLowerCase()) || topic.category.toLowerCase().includes(searchTerm.toLowerCase()) || topic.content && topic.content.toLowerCase().includes(searchTerm.toLowerCase())).filter(topic => selectedSubjectFilter ? topic.category === selectedSubjectFilter : true).filter(topic => selectedTopicFilter ? topic.topic === selectedTopicFilter : true).filter(topic => {
    // Apply personal filters
    if (personalFilter === 'my-topics') {
      return topic.author === 'Ben';
    } else if (personalFilter === 'my-replies') {
      return (topic.repliedBy || []).includes('currentUser');
    }
    return true;
  }).filter(topic => {
    // Apply visibility filter if active
    if (visibilityFilter === 'all') {
      return true;
    } else if (visibilityFilter === 'public') {
      return topic.visibility === 'public';
    } else if (visibilityFilter === 'institution') {
      return topic.visibility === 'institution';
    }
    return true;
  }).filter(topic => {
    // If no filters are active, show all topics
    if (!activeFilters.teacherApproved && !activeFilters.studentSelected && !activeFilters.mostLiked) {
      return true;
    }
    // Apply the active filters
    return activeFilters.teacherApproved && topic.teacherApprovedId || activeFilters.studentSelected && topic.bestAnswerId || activeFilters.mostLiked && topic.mostLikedAnswerId && (!topic.teacherApprovedId || topic.mostLikedAnswerId !== topic.teacherApprovedId) && (!topic.bestAnswerId || topic.mostLikedAnswerId !== topic.bestAnswerId);
  });
  const sortedAndFilteredTopics = sortTopics(filteredTopics);
  const handleSubmitNewTopic = (topicData: any) => {
    const newTopic: ForumTopicType = {
      id: Date.now(),
      title: topicData.title,
      author: 'Ben',
      authorType: 'student',
      category: topicData.category || '',
      topic: topicData.topic || '',
      replies: 0,
      views: 0,
      likes: 0,
      likedBy: [],
      time: 'Şimdi',
      content: topicData.content,
      visibility: topicData.visibility || 'public',
      selectedUsers: topicData.selectedUsers || [],
      type: activeTab,
      image: topicData.image ? URL.createObjectURL(topicData.image) : undefined,
      repliedBy: []
    };
    // Add the new topic at the beginning of the array
    const updatedTopics = [newTopic, ...topics];
    setTopics(updatedTopics);
    // Close the modal
    setShowNewTopic(false);
    setAskModalStep(1);
    setAskModalType(null);
    // Reset form data
    setFormData({
      title: '',
      category: '',
      topic: '',
      content: '',
      image: null,
      imagePreview: null,
      visibility: 'public',
      selectedTeachers: []
    });
    // Set the newly created topic as selected to navigate to it
    setSelectedTopic(newTopic);
  };
  // Update handleAddReply to properly track user replies
  const handleAddReply = (topicId: number, replyContent: string, replyToId?: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        // Update reply count
        const updatedReplies = topic.replies + 1;
        // Add current user to repliedBy array if not already there
        const updatedRepliedBy = topic.repliedBy || [];
        if (!updatedRepliedBy.includes('currentUser')) {
          updatedRepliedBy.push('currentUser');
        }
        return {
          ...topic,
          replies: updatedReplies,
          repliedBy: updatedRepliedBy
        };
      }
      return topic;
    }));
  };
  const handleLikeTopic = (topicId: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        const isLiked = (topic.likedBy || []).includes('currentUser');
        return {
          ...topic,
          likes: isLiked ? topic.likes - 1 : topic.likes + 1,
          likedBy: isLiked ? (topic.likedBy || []).filter(id => id !== 'currentUser') : [...(topic.likedBy || []), 'currentUser']
        };
      }
      return topic;
    }));
  };
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFormData({
        ...formData,
        image: file,
        imagePreview: URL.createObjectURL(file)
      });
    }
  };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setFormData({
        ...formData,
        image: file,
        imagePreview: URL.createObjectURL(file)
      });
    }
  };
  const handleRemoveImage = () => {
    setFormData({
      ...formData,
      image: null,
      imagePreview: null
    });
  };
  const handleSelectTeacher = (teacherId: string) => {
    if (!formData.selectedTeachers.includes(teacherId)) {
      setFormData({
        ...formData,
        selectedTeachers: [...formData.selectedTeachers, teacherId]
      });
    }
    setSearchTeacherTerm('');
    setShowTeacherDropdown(false);
  };
  const handleRemoveTeacher = (teacherId: string) => {
    setFormData({
      ...formData,
      selectedTeachers: formData.selectedTeachers.filter(id => id !== teacherId)
    });
  };
  // Reset filters
  const handleResetFilters = () => {
    setSelectedSubjectFilter('');
    setSelectedTopicFilter('');
    setAvailableTopicFilters([]);
    setPersonalFilter('all');
  };
  // Update the bestAnswerId or teacherApprovedId when a selection is made in ForumTopic
  const handleAnswerSelection = (topicId: number, answerId: number, selectionType: 'student' | 'teacher') => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        if (selectionType === 'student') {
          return {
            ...topic,
            bestAnswerId: answerId
          };
        } else if (selectionType === 'teacher') {
          return {
            ...topic,
            teacherApprovedId: answerId
          };
        }
      }
      return topic;
    }));
  };
  // Update the mostLikedAnswerId when likes change
  const handleUpdateMostLiked = (topicId: number, mostLikedAnswerId: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        return {
          ...topic,
          mostLikedAnswerId
        };
      }
      return topic;
    }));
  };
  const handleArchiveTopic = (topicId: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        const isArchived = topic.archived || false;
        return {
          ...topic,
          archived: !isArchived
        };
      }
      return topic;
    }));
    // Save to localStorage for archived forum questions
    const topicToArchive = topics.find(topic => topic.id === topicId);
    if (topicToArchive) {
      const archivedForumQuestions = JSON.parse(localStorage.getItem('archivedForumQuestions') || '[]');
      const isAlreadyArchived = archivedForumQuestions.some((q: any) => q.id === topicId);
      if (!isAlreadyArchived && !topicToArchive.archived) {
        // Add to archived questions
        const archivedQuestion = {
          id: topicToArchive.id,
          title: topicToArchive.title,
          content: topicToArchive.content,
          subject: topicToArchive.category,
          topic: topicToArchive.topic || 'Genel',
          image: topicToArchive.image,
          forumDate: topicToArchive.time,
          archivedDate: new Date().toISOString(),
          notes: '',
          noteImages: [],
          bestAnswer: null,
          teacherApproved: null,
          mostLiked: null
        };
        // Find best answer, teacher approved or most liked answer
        if (topicToArchive.bestAnswerId || topicToArchive.teacherApprovedId || topicToArchive.mostLikedAnswerId) {
          // This would fetch the actual answer content in a real app
          // For now, we'll use placeholder text
          if (topicToArchive.teacherApprovedId) {
            archivedQuestion.teacherApproved = 'Bu sorunun çözümünde, üslü sayıların özelliklerini doğru kullanmanız önemli. Negatif kuvvetlerin işlem sırasını ve paydaya geçiş kurallarını hatırlayın.';
          }
          if (topicToArchive.bestAnswerId) {
            archivedQuestion.bestAnswer = 'Ben de benzer bir soruyla karşılaşmıştım. Şu şekilde çözdüm: Öncelikle tüm üsleri pozitif yaparak başladım. Sonra ortak paydada topladım.';
          }
          if (topicToArchive.mostLikedAnswerId && topicToArchive.mostLikedAnswerId !== topicToArchive.bestAnswerId && topicToArchive.mostLikedAnswerId !== topicToArchive.teacherApprovedId) {
            archivedQuestion.mostLiked = 'Üslü sayılarda negatif kuvvet kuralını unutmayın: a^(-n) = 1/(a^n). Bu tür sorularda önce bütün üsleri pozitif hale getirip, sonra işlemleri yapmak işinizi kolaylaştıracaktır.';
          }
        }
        archivedForumQuestions.push(archivedQuestion);
        localStorage.setItem('archivedForumQuestions', JSON.stringify(archivedForumQuestions));
      } else if (isAlreadyArchived && topicToArchive.archived) {
        // Remove from archived questions
        const updatedArchivedQuestions = archivedForumQuestions.filter((q: any) => q.id !== topicId);
        localStorage.setItem('archivedForumQuestions', JSON.stringify(updatedArchivedQuestions));
      }
    }
  };
  const {
    showToast,
    ToastContainer
  } = useToast();
  // Check URL for question ID on component mount - use a separate effect with proper dependency
  useEffect(() => {
    // Only run this effect if topics array has been initialized and has content
    if (!topics || topics.length === 0) return;
    // First check if we have state from navigate (from archive)
    const locationState = window.history.state?.usr;
    if (locationState?.openTopicId) {
      const foundTopic = topics.find(topic => topic.id === locationState.openTopicId);
      if (foundTopic) {
        setSelectedTopic(foundTopic);
        // Increment views when a topic is viewed
        setTopics(topics.map(t => t.id === locationState.openTopicId ? {
          ...t,
          views: t.views + 1
        } : t));
        return; // Exit after handling state
      }
    }
    // If no state, check URL parameter
    const path = window.location.pathname;
    const match = path.match(/\/forum\/konu\/(\d+)/);
    if (match && match[1]) {
      const questionId = parseInt(match[1]);
      const foundTopic = topics.find(topic => topic.id === questionId);
      if (foundTopic) {
        setSelectedTopic(foundTopic);
        // Increment views when a topic is viewed
        setTopics(topics.map(t => t.id === questionId ? {
          ...t,
          views: t.views + 1
        } : t));
      }
    }
  }, [topics]); // Use topics instead of topics.length to ensure it runs when topics change
  return <div className="space-y-6" data-id="element-1852">
      {!selectedTopic ? <>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-1853">
            <h1 className="text-2xl font-bold" data-id="element-1854">Forum</h1>
            <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-1855">
              {/* Improved search bar with glowing border */}
              <div className="relative flex-1 sm:w-64" data-id="element-1856">
                <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1857">
                  <div className="relative bg-black/90 rounded-lg" data-id="element-1858">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-400" data-id="element-1859" />
                    <input type="text" placeholder="Ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-transparent text-white rounded-lg pl-10 pr-4 py-2 focus:outline-none border-none" data-id="element-1860" />
                  </div>
                </div>
              </div>
              <button onClick={() => setShowNewTopic(true)} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg text-white hover:from-purple-700 hover:to-indigo-700 transition-colors whitespace-nowrap" data-id="element-1861">
                <Plus className="w-4 h-4" data-id="element-1862" />
                Soru Sor
              </button>
            </div>
          </div>
          {/* Personal Filters */}
          <div className="flex flex-wrap gap-3 mb-4" data-id="element-1863">
            <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1864">
              <div className="relative bg-black/90 rounded-lg flex" data-id="element-1865">
                <button onClick={() => setPersonalFilter('all')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'all' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-1866">
                  <ListFilter className="w-4 h-4" data-id="element-1867" />
                  <span data-id="element-1868">Tüm Konular</span>
                </button>
                <button onClick={() => setPersonalFilter('my-topics')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'my-topics' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-1869">
                  <User className="w-4 h-4" data-id="element-1870" />
                  <span data-id="element-1871">Sorduklarım</span>
                </button>
                <button onClick={() => setPersonalFilter('my-replies')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'my-replies' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-1872">
                  <MessageSquareDashed className="w-4 h-4" data-id="element-1873" />
                  <span data-id="element-1874">Yanıtladıklarım</span>
                </button>
              </div>
            </div>
          </div>
          {/* Subject, Topic, and Visibility Filtering */}
          <div className="flex flex-wrap gap-3 mb-4" data-id="element-1875">
            {/* Subject Filter */}
            <div className="relative" data-id="element-1876">
              <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-1877">
                <Filter className="w-4 h-4" data-id="element-1878" />
                <span data-id="element-1879">Ders: </span>
                <span className="text-purple-400" data-id="element-1880">
                  {selectedSubjectFilter || 'Tümü'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-1881" />
              </button>
              {showSubjectDropdown && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-1882">
                  <button onClick={() => {
              setSelectedSubjectFilter('');
              setShowSubjectDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedSubjectFilter === '' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1883">
                    Tümü
                  </button>
                  {lgsSubjects.map(subject => <button key={subject.id} onClick={() => {
              setSelectedSubjectFilter(subject.title);
              setShowSubjectDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedSubjectFilter === subject.title ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1884">
                      {subject.title}
                    </button>)}
                </div>}
            </div>
            {/* Topic Filter - Only enabled when a subject is selected */}
            <div className="relative" data-id="element-1885">
              <button onClick={() => {
            if (selectedSubjectFilter) {
              setShowTopicDropdown(!showTopicDropdown);
            }
          }} disabled={!selectedSubjectFilter} className={`flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 transition-colors ${selectedSubjectFilter ? 'hover:border-purple-500/50' : 'opacity-50 cursor-not-allowed'}`} data-id="element-1886">
                <Filter className="w-4 h-4" data-id="element-1887" />
                <span data-id="element-1888">Konu: </span>
                <span className="text-purple-400" data-id="element-1889">
                  {selectedTopicFilter || 'Tümü'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-1890" />
              </button>
              {showTopicDropdown && selectedSubjectFilter && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-1891">
                  <button onClick={() => {
              setSelectedTopicFilter('');
              setShowTopicDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedTopicFilter === '' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1892">
                    Tümü
                  </button>
                  {availableTopicFilters.map(topic => <button key={topic} onClick={() => {
              setSelectedTopicFilter(topic);
              setShowTopicDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedTopicFilter === topic ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1893">
                      {topic}
                    </button>)}
                </div>}
            </div>
            {/* New Visibility Filter */}
            <div className="relative" data-id="element-1894">
              <button onClick={() => setShowVisibilityDropdown(!showVisibilityDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-1895">
                <Eye className="w-4 h-4" data-id="element-1896" />
                <span data-id="element-1897">Görünürlük: </span>
                <span className="text-purple-400" data-id="element-1898">
                  {visibilityFilter === 'all' ? 'Tümü' : visibilityFilter === 'public' ? 'Herkese Açık' : 'Kurumuma Özel'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-1899" />
              </button>
              {showVisibilityDropdown && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-1900">
                  <button onClick={() => {
              setVisibilityFilter('all');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'all' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1901">
                    Tümü
                  </button>
                  <button onClick={() => {
              setVisibilityFilter('public');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'public' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1902">
                    Herkese Açık
                  </button>
                  <button onClick={() => {
              setVisibilityFilter('institution');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'institution' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1903">
                    Sadece Kurumuma Özel
                  </button>
                </div>}
            </div>
            {/* Reset Filters Button - Only shown when filters are active */}
            {(selectedSubjectFilter || selectedTopicFilter || personalFilter !== 'all' || visibilityFilter !== 'all') && <button onClick={() => {
          handleResetFilters();
          setVisibilityFilter('all');
        }} className="flex items-center gap-2 px-4 py-2 bg-red-500/20 text-red-400 rounded-lg border border-red-500/30 hover:bg-red-500/30 transition-colors" data-id="element-1904">
                <X className="w-4 h-4" data-id="element-1905" />
                Filtreleri Temizle
              </button>}
          </div>
          {/* Icon Filters - Updated to be actual filters */}
          <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 mb-6" data-id="element-1906">
            <div className="relative p-4 bg-black/95 rounded-lg" data-id="element-1907">
              <div className="flex flex-wrap gap-4 items-center text-sm" data-id="element-1908">
                <span className="text-gray-300 font-medium" data-id="element-1909">Filtrele:</span>
                <IconFilter icon={<CheckCheck className="w-4 h-4" data-id="element-1911" />} iconColor="green-400" label="Öğretmen Onaylı Çözüm" isActive={activeFilters.teacherApproved} onClick={() => setActiveFilters({
              ...activeFilters,
              teacherApproved: !activeFilters.teacherApproved
            })} data-id="element-1910" />
                <IconFilter icon={<Heart className="w-4 h-4" data-id="element-1913" />} iconColor="purple-400" label="En Beğenilen Yanıt" isActive={activeFilters.mostLiked} onClick={() => setActiveFilters({
              ...activeFilters,
              mostLiked: !activeFilters.mostLiked
            })} data-id="element-1912" />
                <IconFilter icon={<Star className="w-4 h-4" data-id="element-1915" />} iconColor="blue-400" label="Aradığım Cevap" isActive={activeFilters.studentSelected} onClick={() => setActiveFilters({
              ...activeFilters,
              studentSelected: !activeFilters.studentSelected
            })} data-id="element-1914" />
              </div>
            </div>
          </div>
          <div className="mb-6" data-id="element-1916">
            <div className="border-b border-gray-800" data-id="element-1917">
              <div className="flex" data-id="element-1918">
                <button onClick={() => setActiveTab('question')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'question' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-1919">
                  Soru Çözüm
                  {activeTab === 'question' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-1920"></span>}
                </button>
                <button onClick={() => setActiveTab('other')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'other' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-1921">
                  Diğer
                  {activeTab === 'other' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-1922"></span>}
                </button>
              </div>
            </div>
          </div>
          {/* Sorting Options */}
          <div className="flex justify-end mb-4" data-id="element-1923">
            <div className="relative" data-id="element-1924">
              <button onClick={() => setShowSortDropdown(!showSortDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-1925">
                <ArrowDownAZ className="w-4 h-4" data-id="element-1926" />
                <span data-id="element-1927">Sırala: </span>
                <span className="text-purple-400" data-id="element-1928">
                  {sortOption === 'newest' ? 'En Yeniler' : sortOption === 'mostReplies' ? 'En Çok Yanıtlananlar' : 'En Beğenilenler'}
                </span>
              </button>
              {showSortDropdown && <div className="absolute right-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-1929">
                  <button onClick={() => {
              setSortOption('newest');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'newest' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1930">
                    <div className="flex items-center gap-2" data-id="element-1931">
                      <ArrowDownAZ className="w-4 h-4" data-id="element-1932" />
                      <span data-id="element-1933">En Yeniler</span>
                    </div>
                  </button>
                  <button onClick={() => {
              setSortOption('mostReplies');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'mostReplies' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1934">
                    <div className="flex items-center gap-2" data-id="element-1935">
                      <MessageSquareText className="w-4 h-4" data-id="element-1936" />
                      <span data-id="element-1937">En Çok Yanıtlananlar</span>
                    </div>
                  </button>
                  <button onClick={() => {
              setSortOption('mostLikes');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'mostLikes' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-1938">
                    <div className="flex items-center gap-2" data-id="element-1939">
                      <Heart className="w-4 h-4" data-id="element-1940" />
                      <span data-id="element-1941">En Beğenilenler</span>
                    </div>
                  </button>
                </div>}
            </div>
          </div>
          {/* Topic Content */}
          <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1942">
            <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-1943">
              <div className="space-y-4" data-id="element-1944">
                {sortedAndFilteredTopics.map(topic => <div key={topic.id} className={`p-4 rounded-lg bg-black/80 border ${topic.author === 'Ben' ? 'border-blue-500/30 hover:border-blue-500/50' : 'border-white/10 hover:border-purple-500/30'} transition-colors cursor-pointer`} onClick={() => {
              setSelectedTopic(topic);
              // Increment views when a topic is viewed
              setTopics(topics.map(t => t.id === topic.id ? {
                ...t,
                views: t.views + 1
              } : t));
            }} data-id="element-1945">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-1946">
                      <div className="flex-1" data-id="element-1947">
                        <div className="flex items-center gap-2" data-id="element-1948">
                          <h3 className="font-medium hover:text-purple-400 cursor-pointer" data-id="element-1949">
                            {topic.title}
                          </h3>
                          {topic.author === 'Ben' && <span className="px-2 py-0.5 text-xs rounded-full bg-blue-500/20 text-blue-400 whitespace-nowrap" data-id="element-1950">
                              Benim Sorum
                            </span>}
                          {topic.teacherApprovedId && <span className="text-green-400 flex items-center" title="Öğretmen Onaylı Çözüm" data-id="element-1951">
                              <CheckCheck className="w-4 h-4" data-id="element-1952" />
                            </span>}
                          {topic.bestAnswerId && <span className="text-blue-400 flex items-center" title="Aradığım Cevap" data-id="element-1953">
                              <Star className="w-4 h-4" data-id="element-1954" />
                            </span>}
                          {topic.mostLikedAnswerId && (!topic.teacherApprovedId || topic.mostLikedAnswerId !== topic.teacherApprovedId) && (!topic.bestAnswerId || topic.mostLikedAnswerId !== topic.bestAnswerId) && <span className="text-purple-400 flex items-center" title="En Beğenilen Yanıt" data-id="element-1955">
                                <Heart className="w-4 h-4" data-id="element-1956" />
                              </span>}
                          {topic.image && <span className="text-purple-400 flex items-center" data-id="element-1957">
                              <ImageIcon className="w-4 h-4" data-id="element-1958" />
                            </span>}
                        </div>
                        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-400" data-id="element-1959">
                          <span data-id="element-1960">{topic.author}</span>
                          {topic.category && <span className={`px-2 py-1 rounded-full ${getCategoryColor(topic.category)}`} data-id="element-1961">
                              {topic.category}
                            </span>}
                          {topic.topic && <span className="px-2 py-1 rounded-full bg-purple-400/10 text-purple-400" data-id="element-1962">
                              {topic.topic}
                            </span>}
                          <span data-id="element-1963">{topic.time}</span>
                          {topic.visibility === 'private' && <span className="px-2 py-1 rounded-full bg-indigo-400/10 text-indigo-400" data-id="element-1964">
                              Özel
                            </span>}
                          {topic.visibility === 'institution' && <span className="px-2 py-1 rounded-full bg-amber-400/10 text-amber-400" data-id="element-1965">
                              Kurumuma Özel
                            </span>}
                        </div>
                        {/* Show a preview of the content */}
                        {topic.content && <div className="mt-2 text-sm text-gray-400 line-clamp-2" data-id="element-1966">
                            {topic.content}
                          </div>}
                      </div>
                      <div className="flex items-center gap-6 text-sm text-gray-400" data-id="element-1967">
                        <button className={`flex items-center gap-1 ${topic.archived ? 'text-purple-400' : 'text-gray-400'} hover:text-purple-400 transition-colors`} onClick={e => {
                    e.stopPropagation();
                    handleArchiveTopic(topic.id);
                    showToast(topic.archived ? 'Soru arşivden kaldırıldı' : 'Soru arşive eklendi', 'success');
                  }} title="Arşive Ekle" data-id="element-1968">
                          <Bookmark className="w-4 h-4" fill={topic.archived ? 'currentColor' : 'none'} data-id="element-1969" />
                        </button>
                        <button className={`flex items-center gap-1 ${(topic.likedBy || []).includes('currentUser') ? 'text-purple-400' : 'text-gray-400'} hover:text-purple-400 transition-colors`} onClick={e => {
                    e.stopPropagation();
                    handleLikeTopic(topic.id);
                  }} data-id="element-1970">
                          <ThumbsUp className="w-4 h-4" fill={(topic.likedBy || []).includes('currentUser') ? 'currentColor' : 'none'} data-id="element-1971" />
                          <span data-id="element-1972">{topic.likes}</span>
                        </button>
                        <div className="flex items-center gap-1" data-id="element-1973">
                          <MessageSquare className="w-4 h-4" data-id="element-1974" />
                          <span data-id="element-1975">{topic.replies}</span>
                        </div>
                        <div className="flex items-center gap-1" data-id="element-1976">
                          <Eye className="w-4 h-4" data-id="element-1977" />
                          <span data-id="element-1978">{topic.views}</span>
                        </div>
                      </div>
                    </div>
                  </div>)}
                {sortedAndFilteredTopics.length === 0 && <div className="text-center py-8 text-gray-400" data-id="element-1979">
                    {personalFilter === 'my-topics' ? 'Henüz konu açmadınız. İlk konuyu siz başlatın!' : personalFilter === 'my-replies' ? 'Henüz yanıt yazmadınız. Diğer kullanıcıların konularına yanıt verin!' : activeTab === 'question' ? 'Henüz soru çözüm konusu bulunmuyor. İlk soruyu siz sorun!' : 'Henüz tartışma konusu bulunmuyor. İlk konuyu siz başlatın!'}
                  </div>}
              </div>
            </div>
          </div>
        </> : <ForumTopic topic={selectedTopic} onClose={() => setSelectedTopic(null)} onAddReply={handleAddReply} onUpdateBestAnswer={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        bestAnswerId: answerId
      } : topic));
    }} onUpdateTeacherApproved={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        teacherApprovedId: answerId
      } : topic));
    }} onUpdateMostLiked={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        mostLikedAnswerId: answerId
      } : topic));
    }} onArchive={handleArchiveTopic} data-id="element-1980" />}
      {/* New Forum Topic Modal */}
      {showNewTopic && <NewForumTopic onClose={() => setShowNewTopic(false)} onSubmit={handleSubmitNewTopic} data-id="element-1981" />}
      {/* Toast container */}
      <ToastContainer data-id="element-1982" />
    </div>;
}